/* SPICY SOUTH: PDP social proof controls. 2026-10-04.
   Arrows and a "2 / 6" counter for snippets/ss-pdp-proof.liquid. The strip
   is native scroll-snap and works without this file; this only adds the
   buttons. No dependencies, no layout reads inside the scroll loop beyond
   one rAF-throttled scrollLeft. */
(function () {
  function init(root) {
    if (root.dataset.ssProofInit) return;
    root.dataset.ssProofInit = '1';
    var vp = root.querySelector('[data-ss-proof-viewport]');
    var prev = root.querySelector('[data-ss-proof-prev]');
    var next = root.querySelector('[data-ss-proof-next]');
    var counter = root.querySelector('[data-ss-proof-counter]');
    if (!vp || !prev || !next) return;
    var cards = vp.querySelectorAll('.ss-voices__card');
    var total = cards.length;
    if (total < 2) { root.querySelector('.ss-voices__arrows').style.display = 'none'; return; }

    function step() {
      var gap = parseFloat(getComputedStyle(cards[0].parentNode).columnGap) || 0;
      return cards[0].getBoundingClientRect().width + gap;
    }
    function index() {
      var max = vp.scrollWidth - vp.clientWidth;
      if (vp.scrollLeft >= max - 4) return total - 1;
      return Math.max(0, Math.min(total - 1, Math.round(vp.scrollLeft / step())));
    }
    var ticking = false;
    function update() {
      ticking = false;
      var i = index();
      prev.disabled = i === 0;
      next.disabled = i === total - 1;
      if (counter) counter.textContent = (i + 1) + ' / ' + total;
    }
    function go(dir) {
      vp.scrollBy({ left: dir * step(), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    }
    prev.addEventListener('click', function () { go(-1); });
    next.addEventListener('click', function () { go(1); });
    vp.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; requestAnimationFrame(update); }
    }, { passive: true });
    vp.addEventListener('scrollend', update);
    root.classList.add('is-ready');
    update();
  }
  function boot() { document.querySelectorAll('[data-ss-voices]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  /* Variant changes can re-render the details column. */
  document.addEventListener('shopify:section:load', boot);
  var queued = false;
  new MutationObserver(function () {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () { queued = false; boot(); });
  }).observe(document.body, { childList: true, subtree: true });
})();
